module.exports = __webpack_public_path__ + "img/improcedente.ac6d0887.png";